import { create } from 'zustand';
import type { MediaItem } from './settings';

/** The slide currently on screen, for widgets that describe it (photo location & date). */
interface NowShowing {
  /** null while an ambient scene is showing. */
  item: MediaItem | null;
  /** Slide counter: changes on every advance, even when the same item repeats. */
  cycle: number;
  /** When this slide appeared (ms since epoch). */
  startedAt: number;
  /** How long the slide stays up, in seconds. */
  durationSec: number;
  show: (item: MediaItem | null, cycle: number, durationSec: number) => void;
}

export const useNowShowing = create<NowShowing>()((set) => ({
  item: null,
  cycle: 0,
  startedAt: Date.now(),
  durationSec: 30,
  show: (item, cycle, durationSec) => set({ item, cycle, durationSec, startedAt: Date.now() }),
}));
